import { render, staticRenderFns } from "./PricingBanner.vue?vue&type=template&id=b8001e8a&scoped=true&"
import script from "./PricingBanner.vue?vue&type=script&lang=ts&"
export * from "./PricingBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PricingBanner.vue?vue&type=style&index=0&id=b8001e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8001e8a",
  null
  
)

export default component.exports